import React from 'react'
import Slider from "react-slick"
import slide1 from './assets/img/slider1.jpg'

export class SliderComponent extends React.Component {
    render(){
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return(
            <Slider {...settings}>
                <div className="item">
                <img src={slide1} alt="test"/>
                </div>
                <div className="item">
                <img src={slide1} alt="test 2"/>
                </div>
            </Slider>
        );
    }
}